import * as React from 'react'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { Flex } from '@radix-ui/themes'
import { styles } from './styles.css'
import warn from './warn.svg'
import calendar from './calendar.svg'
import box from './box.svg'
import { SubscriptionSchedule, SubscriptionInventory } from '~/api-client/data-contracts'

type Props = {
  schedules: SubscriptionSchedule[]
  selectedInventories: SubscriptionInventory[]
  delayedWeek?: number
}

const formatDate = (date: Date) => {
  return format(date, 'M/d（E）', { locale: ja })
}

export const EstimatedDelivery: React.FC<Props> = ({ schedules, selectedInventories, delayedWeek = 0 }) => {
  const selectedInventory = selectedInventories[0]
  const selectedSchedule = schedules.find((s) => s.relationships.inventory.data.id === selectedInventory?.id)

  if (!selectedSchedule) return null

  const dates = selectedSchedule.attributes.deliver_at.map((ts: number) => new Date(ts * 1000))

  if (dates.length === 0) return null

  const deliverAt = dates.map((date) => formatDate(date)).join('〜')
  const weekday = format(dates[0], 'E', { locale: ja })
  const week = selectedInventory?.attributes.week

  return (
    <div className={styles.card}>
      <Flex direction="column" align="start" gap="4px">
        <p className={styles.heading}>初回のお届け</p>
        <Flex direction="column" align="start" gap="2px">
          <p className={styles.dates}>{deliverAt}</p>
          {dates.length === 1 ? (
            <div>
              {delayedWeek === 0 ? (
                <Flex direction="row" gap="4px">
                  <img src={calendar} className={styles.noteIcon} />
                  <p className={styles.note}>{`月に${selectedInventories.length}回・${weekday}曜日にお届け`}</p>
                </Flex>
              ) : (
                <Flex direction="row" gap="4px">
                  <img src={calendar} className={styles.noteIcon} />
                  <div className={styles.warn}>
                    <span className={styles.warn}>夏季休業期間のため配送スケジュールが変更になります</span>
                    <ul className={styles.delayList}>
                      <li>{`初回のみ第${((week + delayedWeek - 1) % 4) + 1}${weekday}曜日にお届け`}</li>
                      <li>{`2回目以降は第${week}${weekday}曜日にお届け`}</li>
                    </ul>
                  </div>
                </Flex>
              )}
              <Flex direction="row" gap="4px">
                <img src={box} className={styles.noteIcon} />
                <p className={styles.note}>クロネコヤマトで配送（対面でのお受け取り）</p>
              </Flex>
            </div>
          ) : (
            <Flex direction="row" gap="4px">
              <img src={warn} className={styles.noteIcon} />
              <p className={styles.warn}>到着日は郵便番号を入力すると確定します</p>
            </Flex>
          )}
        </Flex>
      </Flex>
    </div>
  )
}
